function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { ADDRESS_FORM_FIELD_MAX_LENGTH, ADDRESS_STATUS_CONSTANTS } from '../../../../customer/addresses/addresses.constants';
import { MetadataOptionsForCodeValuesWithoutPlaceholderSelector, MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { COMMA, EMPTY_STRING } from '../../../../../reducers/constants/common.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { updateOverrideFlag } from '../../../../../reducers/actions/customer.addresses.actions';
import clone from 'ramda/src/clone';
import { setAddress, setAddressKeyForAddressBeingValidatedThroughApi, setAddressKeyForAddressPreviouslyValidatedThroughAPI, setAddressToValidatedAddress, setEditAddressBackToInvalid, setForceShowEditFormAddress, setSuggestedAddressToValidatedAddress } from '../../../../../reducers/actions/address.component.actions';
import { generateKeyFromAddress } from '../../../../../reducers/helpers/address.helper';
import { AddressBeingValidatedSelector, IsForceShowEditFormStatusSelector, IsInvalidAddressOverridableScenarioSelector, IsThereSuggestedAddressesSelector, MduRangeSelector, OVERRIDE_ADDRESS_VALUE, PreviouslyValidatedAddressSelector, SuggestedAddressesSelector, UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../../reducers/selectors/address.component.selectors';
import { COUNTRY_CANADA } from './address.wrapup.constants';
var addressDefaultSettings = {
  addressStates: [],
  addressModel: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    country: '',
    //This is country code
    postalCode: '',
    shipToName: '',
    stateRegionProvince: ''
  },
  isCountryFieldReadonly: false,
  isDisabled: false,
  isShipToFieldVisible: false,
  isValidating: false,
  postalCodeSettings: {},
  requiredFields: {
    /*
        this specifies which address form input fields
        are required (validation-wise and display-wise)
    */
    country: false,
    addressLine1: false,
    addressLine2: false,
    city: false,
    stateRegionProvince: false,
    postalCode: false
  }
};
var AddressWrapupController = /*#__PURE__*/function () {
  function AddressWrapupController($ngRedux, $anchorScroll, $location, $timeout) {
    _classCallCheck(this, AddressWrapupController);
    Object.assign(this, clone(addressDefaultSettings), {
      $anchorScroll: $anchorScroll,
      $location: $location,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      ADDRESS_STATUS_CONSTANTS: ADDRESS_STATUS_CONSTANTS,
      CoreLocaleKeys: CoreLocaleKeys,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys,
      singleAddressFormFormApi: {},
      //using this to hook into AngularJS Forms
      formMaxLengthValidation: ADDRESS_FORM_FIELD_MAX_LENGTH,
      onModelChange: this.onModelChange.bind(this),
      setAddress: this.setAddress.bind(this),
      setAddressToSuggestedAddress: this.setAddressToSuggestedAddress.bind(this),
      setSuggestedAddresses: this.setSuggestedAddresses.bind(this),
      previousAddressKey: null,
      canScrollToSuggested: false
    });
  }
  return _createClass(AddressWrapupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        setAddress: setAddress,
        setAddressKeyForAddressBeingValidatedThroughApi: setAddressKeyForAddressBeingValidatedThroughApi,
        setAddressKeyForAddressPreviouslyValidatedThroughAPI: setAddressKeyForAddressPreviouslyValidatedThroughAPI,
        setAddressToValidatedAddress: setAddressToValidatedAddress,
        setEditAddressBackToInvalid: setEditAddressBackToInvalid,
        setSuggestedAddressToValidatedAddress: setSuggestedAddressToValidatedAddress,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        updateOverrideFlag: updateOverrideFlag
      };
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
        _this.setSuggestedAddresses();
        _this.updateAddressToValidatedAddressFromAPI();
      });
      if (!this.state.addressCountriesLoaded) {
        this.actions.fetchCodeTypes(CODES.AddressCountry);
      }
      if (this.requiredFields) {
        this.isAnyFieldRequired = Object.keys(this.requiredFields).length > 0;
      }
      var addressKey = generateKeyFromAddress(this.addressWrapupModel);
      this.singleAddressFormFormApi.addressKey = addressKey;
      this.isInvalidAddressSetAsValid = false;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      Object.assign(this.addressModel, this.addressWrapupModel);
      if (this.canUpdateAddressReduxState() && generateKeyFromAddress(this.addressModel) !== this.singleAddressFormFormApi.addressKey) {
        this.setAddress(this.addressModel);
      }
    }
  }, {
    key: "mapStateToTarget",
    value: function mapStateToTarget(store) {
      return {
        addressBeingValidated: AddressBeingValidatedSelector(store),
        addressCountries: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.AddressCountry, store),
        addressCountriesLoaded: MetadataCodeLoadedSelector(CODES.AddressCountry, store),
        isInvalidAddressOverridableScenario: IsInvalidAddressOverridableScenarioSelector(store),
        isSuggestedAddressesPresent: IsThereSuggestedAddressesSelector(store),
        initialValidatedAddress: PreviouslyValidatedAddressSelector(store),
        isForceShowEditForm: IsForceShowEditFormStatusSelector(store),
        mduRange: MduRangeSelector(store),
        suggestedAddresses: SuggestedAddressesSelector(store),
        unvalidatedAddresses: UnvalidatedAddressesSelector(store),
        validatedAddresses: ValidatedAddressesSelector(store)
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (this.showSuggestedForm() && this.isInvalidAddressSetAsValid) {
        this.actions.setEditAddressBackToInvalid(this.originalEnteredAddress, this.lastValidatedAddressForEnteredAddress);
      }
      this.actions.setAddressKeyForAddressBeingValidatedThroughApi(null);
      this.actions.setAddressKeyForAddressPreviouslyValidatedThroughAPI(null);
      this.originalAddressOverwrittenWithValidatedAddress = false;
      this.isOverridden = false;
      this.disconnectRedux();
    }
  }, {
    key: "setSuggestedAddresses",
    value: function setSuggestedAddresses() {
      var _this2 = this;
      if (!this.isOverridden && !this.state.isForceShowEditForm) {
        this.suggestedAddresses = clone(this.state.suggestedAddresses);
        if (this.suggestedAddresses.length) {
          this.selectedSuggestedAddress = this.suggestedAddresses[0].value;
          this.$timeout(function () {
            _this2.setAddressToSuggestedAddress();
          });
        }
      }
    }
  }, {
    key: "showEditForm",
    value: function showEditForm() {
      this.actions.setForceShowEditFormAddress(true);
      this.isOverridden = false;
      this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI = null;
      if (this.isInvalidAddressSetAsValid) {
        this.actions.setEditAddressBackToInvalid(this.originalEnteredAddress, this.lastValidatedAddressForEnteredAddress);
        this.isInvalidAddressSetAsValid = false;
        this.lastValidatedAddressForEnteredAddress = null;
      }
      this.addressModel = clone(this.originalEnteredAddress);
      this.onModelChange(this.originalEnteredAddress);
    }
  }, {
    key: "onModelChange",
    value: function onModelChange(addressWrapupModel) {
      this.onAddressChange()(addressWrapupModel);
      this.setAddress(addressWrapupModel);
    }

    //TO-DO for security attribute use this function
  }, {
    key: "setAddressToSuggestedAddress",
    value: function setAddressToSuggestedAddress() {
      var selectedSuggestedAddress = this.selectedSuggestedAddress,
        shipToName = this.addressModel.shipToName,
        addressResponseFromApi = this.state.validatedAddresses[this.singleAddressFormFormApi.addressKey];
      var formattedAddress;
      this.isOverridden = true;
      if (this.selectedSuggestedAddress !== OVERRIDE_ADDRESS_VALUE) {
        if (!this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI) {
          this.actions.setAddressKeyForAddressPreviouslyValidatedThroughAPI(this.singleAddressFormFormApi.addressKey, addressResponseFromApi.JobToken);
        }
        if (this.isInvalidAddressSetAsValid) {
          this.actions.setEditAddressBackToInvalid(this.originalEnteredAddress, this.lastValidatedAddressForEnteredAddress);
          this.isInvalidAddressSetAsValid = false;
        }
        formattedAddress = {
          addressLine1: selectedSuggestedAddress.LineOne,
          addressLine2: selectedSuggestedAddress.LineTwo,
          city: selectedSuggestedAddress.City,
          country: selectedSuggestedAddress.Country,
          //This is country code
          postalCode: selectedSuggestedAddress.PostalCode,
          shipToName: shipToName,
          stateRegionProvince: selectedSuggestedAddress.State
        };
        var newAddressKey = generateKeyFromAddress(formattedAddress);
        this.actions.setAddressKeyForAddressBeingValidatedThroughApi(newAddressKey);
        this.actions.setSuggestedAddressToValidatedAddress(formattedAddress, addressResponseFromApi.JobToken);
        this.onModelChange(formattedAddress);
        this.actions.updateOverrideFlag(null);
      } else if (this.originalEnteredAddress) {
        this.isInvalidAddressSetAsValid = true;
        if (!this.lastValidatedAddressForEnteredAddress) {
          this.lastValidatedAddressForEnteredAddress = addressResponseFromApi;
        }
        if (this.selectedSuggestedAddress === OVERRIDE_ADDRESS_VALUE) {
          this.actions.updateOverrideFlag(true);
        }
        this.actions.setAddressToValidatedAddress(this.originalEnteredAddress, addressResponseFromApi.JobToken);
        this.onModelChange(this.originalEnteredAddress);
      }
    }
  }, {
    key: "setAddress",
    value: function setAddress(addressWrapupModel) {
      /*
          Before using API to validate, we want to make sure that
          the address passes ui validation requirements.
          Also we should only be validating if the fields are required.
      */
      if (this.canUpdateAddressReduxState()) {
        var addressKey = generateKeyFromAddress(addressWrapupModel);
        if (this.state.isForceShowEditForm) {
          //At this point they started editing the form from suggestion so reset everything
          this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI = null;
        }
        this.actions.setAddress(addressWrapupModel);
        this.actions.setAddressKeyForAddressBeingValidatedThroughApi(addressKey);
        //This will be used by the parentComponent for address validation
        this.singleAddressFormFormApi.addressKey = addressKey;
        if (this.state.isForceShowEditForm || !this.showSuggestedForm()) {
          this.originalEnteredAddress = clone(this.addressModel);
        }
      }
    }
  }, {
    key: "canUpdateAddressReduxState",
    value: function canUpdateAddressReduxState() {
      return (
      //we do not want to use AngularJS form $valid when radio buttons showing
      this.singleAddressFormFormApi && this.singleAddressFormFormApi.$valid || this.showSuggestedForm()) && this.isAnyFieldRequired;
    }
  }, {
    key: "enteredAddress",
    value: function enteredAddress() {
      return this.originalEnteredAddress ? "".concat(this.originalEnteredAddress.addressLine1, ", ").concat(this.originalEnteredAddress.addressLine2 ? this.originalEnteredAddress.addressLine2 + COMMA : EMPTY_STRING, " ").concat(this.originalEnteredAddress.city, ", ").concat(this.originalEnteredAddress.stateRegionProvince, " ").concat(this.originalEnteredAddress.postalCode, ", ").concat(this.originalEnteredAddress.country) : null;
    }
  }, {
    key: "showSuggestedForm",
    value: function showSuggestedForm() {
      if (this.singleAddressFormFormApi && (this.singleAddressFormFormApi.$submitted || this.singleAddressFormFormApi.submitted)) {
        var addressKey = generateKeyFromAddress(this.addressModel);
        if (this.state.isForceShowEditForm) {
          return false;
        }
        if (this.isOverridden) {
          return this.suggestedAddresses.length;
        }
        if (this.state.validatedAddresses[addressKey] && !this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI) {
          //initial setting of address validatedThroughAPI
          this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI = addressKey;
          this.canScrollToSuggested = true;
        }
        var shouldShowSuggestedForm = this.singleAddressFormFormApi.keyForAddressValidatedThroughAPI;

        //TO-DO make sure scrolling works
        if (shouldShowSuggestedForm && this.canScrollToSuggested) {
          var old = this.$location.hash();
          this.$location.hash('addressFormSuggestedAddresses');
          this.$anchorScroll();
          this.$location.hash(old);
          this.canScrollToSuggested = false;
        }
        if (this.state.isInvalidAddressOverridableScenario) {
          //TO-DO we should be referring to this.state.suggestedAddresses
          return this.state.suggestedAddresses;
        }
        return shouldShowSuggestedForm && this.state.validatedAddresses[shouldShowSuggestedForm] && (this.state.validatedAddresses[shouldShowSuggestedForm].SuggestedAddresses || this.state.validatedAddresses[shouldShowSuggestedForm].AddressValidationStatus === ADDRESS_STATUS_CONSTANTS.MDU_VALIDATION_ERROR);
      }
      return false;
    }
  }, {
    key: "updateAddressToValidatedAddressFromAPI",
    value: function updateAddressToValidatedAddressFromAPI() {
      if (this.singleAddressFormFormApi && this.singleAddressFormFormApi.$submitted) {
        var addressKey = generateKeyFromAddress(this.addressModel),
          validatedAddress = this.state.validatedAddresses[addressKey] && this.state.validatedAddresses[addressKey].ValidatedAddress,
          shipToName = this.addressModel.shipToName,
          addressValidationStatus = this.state.validatedAddresses[addressKey] && this.state.validatedAddresses[addressKey].AddressValidationStatus;
        this.addressValidationStatus = addressValidationStatus;
        this.isMissingUnitNumber = false;
        if (addressValidationStatus === ADDRESS_STATUS_CONSTANTS.MDU_VALIDATION_ERROR) {
          this.isMissingUnitNumber = true;
          this.mduRange = validatedAddress && validatedAddress.MduRange;
        }
        if (validatedAddress && !this.originalAddressOverwrittenWithValidatedAddress) {
          //Original address set through API
          var formattedAddress = {
            addressLine1: validatedAddress.LineOne || validatedAddress.addressLine1,
            addressLine2: validatedAddress.LineTwo || validatedAddress.addressLine2,
            city: validatedAddress.City || validatedAddress.city,
            country: validatedAddress.Country || validatedAddress.country,
            //This is country code
            postalCode: validatedAddress.PostalCode || validatedAddress.postalCode,
            shipToName: shipToName,
            stateRegionProvince: validatedAddress.State || validatedAddress.stateRegionProvince
          };

          //situation where the API returns a validated address for an address that ALMOST matches
          this.originalAddressOverwrittenWithValidatedAddress = true;
          this.actions.setAddressToValidatedAddress(formattedAddress, validatedAddress.JobToken, addressValidationStatus);
          this.onModelChange(formattedAddress);
        }
      }
    }
  }, {
    key: "addUnitNumberToAddress",
    value: function addUnitNumberToAddress() {
      if (this.originalEnteredAddress.country === COUNTRY_CANADA) {
        this.originalEnteredAddress.addressLine1 = this.unitNumber.concat(' ', this.originalEnteredAddress.addressLine1);
      } else {
        this.originalEnteredAddress.addressLine1 = this.originalEnteredAddress.addressLine1.concat(' ', this.unitNumber);
      }
      this.onModelChange(this.originalEnteredAddress);
      this.isMissingUnitNumber = false;
      this.unitNumber = '';
    }
  }]);
}(); //is errors even necessary anymore to pass down?
export default {
  bindings: {
    /*
        why am I passing in stateOptions but not countries?
        Currently in the locations the contextual component is being used,
        the state options selectors have a dependency on the parent element info.
        E.g. stateOptions in customer components are dependent on customerInfo
        stateOptions in modify mobile Number are dependent on mobileInfo.
        Passing it down for now until we resolve this.
    */
    addressStates: '<',
    addressWrapupModel: '<',
    isAddressApiValidationOn: '<?',
    isCountryFieldReadonly: '<?',
    isDisabled: '<?',
    isNewConnectServiceabilityStep: '<?',
    isShipToFieldVisible: '<?',
    onAddressChange: '&',
    postalCodeSettings: '<',
    requiredFields: '<?'
  },
  template: require('./address.wrapup.html'),
  controller: AddressWrapupController,
  controllerAs: 'addressWrapupController'
};